import RepairCategoryPage from "./RepairCategoryPage";

export default function MacbookRepairPage() {
  return (
    <RepairCategoryPage
      category="macbook"
      eyebrow="MacBook Reparatur"
      headline={<>Dein MacBook.<br/><span className="text-zinc-500">Wieder wie am ersten Tag.</span></>}
      subline="Von Hardware-Reparaturen bis zur professionellen Fehlerdiagnose — wir setzen dein MacBook fachgerecht instand und bringen es wieder in Bestform."
      accentColor="#DC1928"
    />
  );
}
